<template>
  <div>
    <h3 v-if="order.trackingNumber && order.shippingProvider">
      {{ $t('shippingProvider') }}: {{ order.shippingProvider }}
    </h3>
    <h3 v-if="order.trackingNumber && order.shippingProvider">
      {{ $t('tracking') }}:
      <a :href="order.trackingLink" class="underline-link-from-center">{{
        order.trackingNumber.toUpperCase()
      }}</a>
    </h3>

    <h3
      class="mb-3"
      v-if="order.shippingMethodDisplayName || (order.reservationStart && order.reservationEnd)"
    >
      <span v-if="order.shippingMethodDisplayName">{{ order.shippingMethodDisplayName }}</span>
      <span v-if="order.reservationStart && order.reservationEnd">
        {{ order.reservationStart | dayOfWeek }} {{ order.reservationStart | formatTime }} -
        {{ order.reservationEnd | formatTime }}</span
      >
    </h3>
    <div class="wc-order-item-list" v-if="!isDetailPage" role="list">
      <WCOrderPanelLineItem
        v-for="(lineItem, ind) in lineItems"
        :key="ind"
        :lineItem="lineItem"
        role="listitem"
      />
      <span
        v-if="$route.name === 'PastOrders' && order.lineItems.length > 0"
        class="p-2 text-center"
        ><router-link
          class="underline-link-from-center"
          :to="`/me/orders/${order.scancode}`"
          :aria-label="`View all items in Order number ${order.scancode}`"
          >{{ $t('viewItemList') }}</router-link
        ></span
      >
    </div>
    <WCBuyItAgainSection v-else :items="lineItems" :showQuantity="true" />
    <div class="d-flex">
      <WCOrderPanelGiftCard v-for="(gc, ind) in order.giftCards" :key="ind" :giftCard="gc" />
    </div>
    <div
      v-if="
        (!order.lineItems || order.lineItems.length === 0) &&
          (!order.giftCards || order.giftCards.length === 0)
      "
    >
      {{ $t('noItemsOnOrder') }}
    </div>
  </div>
</template>

<script>
import WCBuyItAgainSection from '@/modules/user/components/WCBuyItAgainSection/WCBuyItAgainSection.vue';
import WCOrderPanelLineItem from './WCOrderPanelLineItem.vue';
import WCOrderPanelGiftCard from './WCOrderPanelGiftCard.vue';

export default {
  name: 'WCOrderPanelBodyInfo',
  components: { WCOrderPanelLineItem, WCOrderPanelGiftCard, WCBuyItAgainSection },
  props: {
    order: {
      type: Object,
      required: true,
    },
    isDetailPage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
  computed: {
    lineItems() {
      const path = this.$route.name;
      return path === 'PastOrders'
        ? this.order.lineItems.slice(
            0,
            this.order.lineItems.length > 6 ? 6 : this.order.lineItems.length,
          )
        : this.order.lineItems;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';
.wc-order-item-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(7.2rem, 1fr));
  justify-items: center;
  align-items: center;
  column-gap: 0.5rem;
  row-gap: 2rem;
}
</style>
